import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam } from '@hooks/params';

import { selectCarQuotePaymentPage } from './selector';
import {
  carQuoteFetch,
  CarQuoteFetchPayload,
  billingFetch,
  BillingFetchPayload,
} from './action';

export const useCarQuoteFetch = () => {
  const orderNumber = useRouteParam('orderNumber') as string;
  const dispatch = useDispatch();
  const { carQuote } = useSelector(selectCarQuotePaymentPage);
  useEffectOnce(() => {
    const payload: CarQuoteFetchPayload = { orderNumber };
    dispatch(carQuoteFetch(payload));
  });
  return carQuote;
};


export const useBillingFetch = () => {
  const dispatch = useDispatch();
  const billingId = Number(useRouteParam('billingId'));
  const { billing } = useSelector(selectCarQuotePaymentPage);
  useEffectOnce(() => {
    const payload: BillingFetchPayload = { id: billingId };
    dispatch(billingFetch(payload));
  });
  return billing;
};
